import React, { Fragment, useContext, useEffect, useState } from "react";
import {  Item } from "semantic-ui-react";
import TechnicianTransmissionList from "./TechnicianTransmissionList";
import { observer } from "mobx-react-lite";
import TechnicianTransmissionStore from "../../../app/stores/techniciantransmissionStore";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import { Link } from "react-router-dom";

const TechnicianTransmissionDashboard: React.FC = () => {
  const techniciantransmissionStore = useContext(TechnicianTransmissionStore);
  const {
    submitting,
    techniciantransmission: initialFormState,
    loadTechnicianTransmissions,
    uploadingFile,
  } = techniciantransmissionStore;

  useEffect(() => {
    loadTechnicianTransmissions();
  }, []);

  if (techniciantransmissionStore.loadingInitial)
    return <LoadingComponent content="Loading TechnicianTransmissions" />;

  return (
    <Item>
          <TechnicianTransmissionList />
    </Item>
  );
};

export default observer(TechnicianTransmissionDashboard);
